import { COMMON_DOCUMENTS } from './documents';
export const PK = {
    code: 'PK',
    name: 'Pakistan',
    profileVersion: 1,
    readiness: 'ready',
    timezone: 'Asia/Karachi',
    weekend: [6, 0],
    firstDayOfWeek: 1,
    currency: { code: 'PKR', displayFractionDigits: 2, roundToWholeUnits: false },
    subdivisions: [
        { code: 'PK-PB', name: 'Punjab', taxAuthority: 'PRA' },
        { code: 'PK-SD', name: 'Sindh', taxAuthority: 'SRB' },
        { code: 'PK-KP', name: 'Khyber Pakhtunkhwa', taxAuthority: 'KPRA' },
        { code: 'PK-BA', name: 'Balochistan', taxAuthority: 'BRA' },
        { code: 'PK-IS', name: 'Islamabad Capital Territory', taxAuthority: 'FBR-ICT' },
        { code: 'PK-GB', name: 'Gilgit-Baltistan' },
        { code: 'PK-JK', name: 'Azad Jammu and Kashmir' },
    ],
    branchSubdivision: 'when_registered',
    locales: {
        ui: ['en', 'ur-Latn'],
        defaultUi: 'en',
        documentSecondary: null,
        secondaryOnTaxDocuments: 'off',
        secondaryOnClinicalDocuments: 'off',
        formatting: { en: 'en-PK', 'ur-Latn': 'en-PK' },
    },
    phone: { callingCode: '92', trunkPrefix: '0', nationalLengths: [10], mobilePattern: '^3\\d{9}$', example: '03001234567' },
    names: { parts: ['first', 'father', 'last'], labels: { father: 'Father / husband name' }, askLocalName: false },
    identity: {
        documents: [
            {
                type: 'pk_cnic',
                labelKey: 'identity.pk_cnic',
                label: 'CNIC',
                pattern: '^\\d{13}$',
                normalise: 'digits',
                checksum: 'none',
                onChecksumFail: 'warn',
                onPatternFail: 'refuse',
                impliesNationality: 'PK',
                example: '35201-1234567-1',
            },
            {
                type: 'pk_nicop',
                labelKey: 'identity.pk_nicop',
                label: 'NICOP',
                pattern: '^\\d{13}$',
                normalise: 'digits',
                checksum: 'none',
                onChecksumFail: 'warn',
                onPatternFail: 'warn',
                impliesNationality: 'PK',
                example: '35201-1234567-1',
            },
            {
                type: 'pk_bform',
                labelKey: 'identity.pk_bform',
                label: 'B-Form (child registration)',
                pattern: '^\\d{13}$',
                normalise: 'digits',
                checksum: 'none',
                onChecksumFail: 'warn',
                onPatternFail: 'warn',
                impliesNationality: 'PK',
                example: '35201-1234567-1',
            },
            ...COMMON_DOCUMENTS,
        ],
        defaultType: 'pk_cnic',
        autoDetect: false,
        capture: { hospital: 'required', lab: 'hidden', pharmacy: 'hidden' },
        askNationality: false,
        dobCalendars: ['gregory'],
    },
    practitionerRegistries: [{ code: 'PMDC', label: 'PMDC registration' }],
    tax: [
        {
            code: 'pk_sales_tax',
            effectiveFrom: '2000-01-01',
            registration: { labelKey: 'tax.pk_ntn', label: 'NTN', pattern: '^[0-9A-Z-]{7,15}$', checksum: 'none', onFail: 'warn' },
            companyRegistrationLabelKey: null,
            companyRegistrationLabel: null,
            standardRatePct: null,
            serviceDefaultCategory: 'exempt',
            productDefaultCategory: 'exempt',
            qr: null,
            citizenRelief: null,
        },
    ],
    eInvoicing: { scheme: 'fbr_pos', mandatory: 'now', fromDate: null, appliesTo: ['pharmacy'] },
    addOns: [{ code: 'fbr_pos', built: false }],
    feeSplittingDefault: true,
};
//# sourceMappingURL=pk.js.map